import {saveAs} from 'file-saver';
import {createPdfFileName} from './createPdfFileName';

const isMobile = () =>
  /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);

export const openAndDownloadPdf = async (
  doc: React.ReactElement,
  fileName = 'document',
) => {
  const {pdf} = await import('@react-pdf/renderer');
  const blob = await pdf(doc).toBlob();
  const url = URL.createObjectURL(blob);

  try {
    saveAs(blob, createPdfFileName(fileName));

    if (isMobile()) {
      window.open(url, '_blank');
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  }
};
